import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CondoCorporationManagementsSearchState } from '@state/algolia-search/condo-corporation-managements-search/state';
import { Select } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { CondoManagement } from '@models/matter';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { CondoCorporationManagementsDispatch } from '@state/algolia-search/condo-corporation-managements-search/dispatch';

export enum DropdownSelect {
	SELECT_CONDO_CORPORATION_MANAGEMENT = 'SelectCondoCorporationManagement',
}

@UntilDestroy()
@Component({
	selector: 'app-search-management-company-input',
	templateUrl: './search-management-company.component.html',
	standalone: false,
})
export class SearchManagementCompanyComponent implements OnInit {
	public managementCompanyName = '';
	public ICON = ICON;
	public showDropdown = false;
	public loading = false;
	public dropdownSelect = DropdownSelect;

	@Input() label = '';

	@Output() onFocus = new EventEmitter();
	@Output() onCreate = new EventEmitter<string>();
	@Output() onSelect = new EventEmitter();

	@Select(CondoCorporationManagementsSearchState.getList)
	condoCorporationManagements$: Observable<CondoManagement[]>;

	ngOnInit() {
		combineLatest([this.condoCorporationManagements$])
			.pipe(
				untilDestroyed(this),
				map(() => {
					this.loading = false;
				}),
			)
			.subscribe();
	}

	constructor(
		private condoCorporationManagement: CondoCorporationManagementsDispatch,
	) {}

	_onFocus() {
		this.onFocus.emit();
	}

	create() {
		this.onCreate.emit(this.managementCompanyName);
	}

	search = ($event) => {
		this.loading = true;
		this.condoCorporationManagement.Search($event);
	};

	onSelectCondoCorporationManagement = (
		ev: DropdownResult<CondoManagement>,
	) => {
		if (ev.groupType === DropdownSelect.SELECT_CONDO_CORPORATION_MANAGEMENT) {
			this.onSelect.emit(ev);
		}
	};
}
